import { render, staticRenderFns } from "./SalesPointEditView.vue?vue&type=template&id=2500e82a&"
import script from "./SalesPointEditView.vue?vue&type=script&lang=js&"
export * from "./SalesPointEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports